import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import type { SubscriptionFeature } from "../types/subscriptionTypes";

const plans = { sms: "Pro", ai: "Pro+AI" } satisfies Record<SubscriptionFeature, string>;

interface FeatureRequiredProps {
  feature: SubscriptionFeature;
  title?: string;
  message?: string;
  /** Offer the plan page; off when no plan would help, e.g. at the top plan's limit. */
  showPlans?: boolean;
}

/** Locked state for a feature that the current plan does not include. */
export function FeatureRequired({ feature, title, message, showPlans = true }: FeatureRequiredProps) {
  const { goToPlanDetails } = useAppNavigation();
  const { user } = useAuth();
  const { business } = useCurrentBusiness();
  const owner = !!user && business?.ownerId === user.id;
  const upgrade = showPlans && owner;
  return (
    <EmptyState
      title={title ?? `This needs ${plans[feature]}`}
      message={`${message ?? (feature === "sms" ? "Texting customers is included in the Pro and Pro+AI plans." : "AI features are included in the Pro+AI plan.")}${showPlans && !owner ? " Ask the business owner to upgrade." : ""}`}
      action={upgrade ? { label: "See plans", onClick: goToPlanDetails } : undefined}
    />
  );
}
